import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LayoutModule, ReusableHeaderBreadcrumbContainerModule, SharedModule } from "@app/shared";
import { MaterialModule } from '@app/shared/material.module';
import { AuthenticationGuard as AuthGuard } from '@app/shared/services/authguards';
import { OpenscapeLoggedAgentsListComponent } from './openscape-logged-agents-list.component';

const routes: Routes = [
  {
    path: 'loggedin-users', component: OpenscapeLoggedAgentsListComponent, canActivate: [AuthGuard], data: { title: 'Openscape Agents Dashboard' }
  }
];

@NgModule({
  imports: [
    LayoutModule,
    MaterialModule, ReusableHeaderBreadcrumbContainerModule,
    SharedModule,
    RouterModule.forChild(routes),
  ],
  declarations: [OpenscapeLoggedAgentsListComponent]
})
export class OpenscapeLoggedAgentsModule { }
